<template>
  <div>
    <v-card
      class="main--text">
      <v-sheet
        color="blue lighten-5">
        <v-container
          fluid>
          <v-row
            justify=end
            no-gutters>
            <v-col
              cols=auto>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    @click="$emit('info-button-click')">mdi-information-outline</v-icon>
                </template>
                <span>詳細を見る</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row
            justify=center
            >
            <v-avatar size="80px">
              <img :src="teacher.iconUrl" alt="">
            </v-avatar>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=12
              style="text-align:center">
              <h3 class="font-weight-bold">
                  {{teacher.fullName()}}
              </h3>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
      <v-container
        fluid
        >
        <v-row
          no-gutters>
          <v-col>
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    性別
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{teacher.genderInJapanese()}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    大学
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{teacher.university}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </v-col>
        </v-row>
        <v-row
          no-gutters>
          <v-col
            cols=auto>
            <v-subheader>対応可能時間帯</v-subheader>
          </v-col>
        </v-row>
        <v-row
          no-gutters>
          <v-col
            cols=auto>
            <v-chip
              small
              outlined
              text-color="black"
              v-for="(schedule, index) in teacher.availableSchedulesToStrings()"
              :key="index">{{schedule}}</v-chip>
          </v-col>
        </v-row>
        <v-row
          justify=center
          style="margin-top:20px">
          <v-col
            cols=auto>
            <v-btn
              rounded
              depressed
              outlined
              @click="$emit('request-button-click')"
              ><v-icon>far fa-paper-plane</v-icon><span>リクエストを送る</span></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    teacher: Object
  }
}
</script>
